<template>
    <div>
      <Pos_page/>
    </div>
  </template>
  
  <script>
  import Pos_page from "@/components/adminArin/pos_system/pos/Pos_page";
  export default {
    name: "PosPage",
    components: {
        Pos_page
    }
  }
  </script>
  
  <style scoped>
  
  </style>
  